import React from "react";
import { Link } from "react-router-dom";
import BackButton from "../img/icons/icon_blue_back.svg";
import LibraryIcon from "../img/icons/icon_library.svg";
import YtIcon from "../img/video-youtube/icon_yt.png";
import Thumbnail01 from "../img/video-youtube/video-thumbnail01.png";
import Thumbnail02 from "../img/video-youtube/video-thumbnail02.png";
import Thumbnail03 from "../img/video-youtube/video-thumbnail03.png";
import Thumbnail04 from "../img/video-youtube/video-thumbnail04.png";
import Thumbnail05 from "../img/video-youtube/video-thumbnail05.png";
import Thumbnail06 from "../img/video-youtube/video-thumbnail06.png";
import Thumbnail07 from "../img/video-youtube/video-thumbnail07.png";
import Thumbnail08 from "../img/video-youtube/video-thumbnail08.png";
import Thumbnail09 from "../img/video-youtube/video-thumbnail09.png";
import Thumbnail10 from "../img/video-youtube/video-thumbnail10.png";
import Thumbnail11 from "../img/video-youtube/video-thumbnail11.png";
import Thumbnail12 from "../img/video-youtube/video-thumbnail12.png";
import Thumbnail13 from "../img/video-youtube/video-thumbnail13.png";
import Thumbnail14 from "../img/video-youtube/video-thumbnail14.png";
import Thumbnail15 from "../img/video-youtube/video-thumbnail15.png";
import Thumbnail16 from "../img/video-youtube/video-thumbnail16.png";
import Thumbnail17 from "../img/video-youtube/video-thumbnail17.png";
import Thumbnail18 from "../img/video-youtube/video-thumbnail18.png";
import Thumbnail19 from "../img/video-youtube/video-thumbnail19.png";
import Thumbnail20 from "../img/video-youtube/video-thumbnail20.png";
import Thumbnail21 from "../img/video-youtube/video-thumbnail21.png";
import Thumbnail22 from "../img/video-youtube/video-thumbnail22.png";
import Thumbnail23 from "../img/video-youtube/video-thumbnail23.png";
import Thumbnail24 from "../img/video-youtube/video-thumbnail24.png";
import Thumbnail25 from "../img/video-youtube/video-thumbnail25.png";
import Thumbnail26 from "../img/video-youtube/video-thumbnail26.png";
import Thumbnail27 from "../img/video-youtube/video-thumbnail27.png";
import Thumbnail28 from "../img/video-youtube/video-thumbnail28.png";
import Thumbnail29 from "../img/video-youtube/video-thumbnail29.png";
import Thumbnail30 from "../img/video-youtube/video-thumbnail30.png";
import Thumbnail31 from "../img/video-youtube/video-thumbnail31.png";
import Thumbnail32 from "../img/video-youtube/video-thumbnail32.png";
import Thumbnail33 from "../img/video-youtube/video-thumbnail33.png";
import Thumbnail34 from "../img/video-youtube/video-thumbnail34.png";
import Thumbnail35 from "../img/video-youtube/video-thumbnail35.png";
import Thumbnail36 from "../img/video-youtube/video-thumbnail36.png";
import Thumbnail37 from "../img/video-youtube/video-thumbnail37.png";
import Thumbnail38 from "../img/video-youtube/video-thumbnail38.png";
import Thumbnail39 from "../img/video-youtube/video-thumbnail39.png";
import Thumbnail40 from "../img/video-youtube/video-thumbnail40.png";
import Thumbnail41 from "../img/video-youtube/video-thumbnail41.png";
import Thumbnail42 from "../img/video-youtube/video-thumbnail42.png";
import Thumbnail43 from "../img/video-youtube/video-thumbnail43.png";
import Thumbnail44 from "../img/video-youtube/video-thumbnail44.png";
import Thumbnail45 from "../img/video-youtube/video-thumbnail45.png";
import Thumbnail46 from "../img/video-youtube/video-thumbnail46.png";
import Thumbnail47 from "../img/video-youtube/video-thumbnail47.png";
import Thumbnail48 from "../img/video-youtube/video-thumbnail48.png";
import Thumbnail49 from "../img/video-youtube/video-thumbnail49.png";
import Thumbnail50 from "../img/video-youtube/video-thumbnail50.png";
import Thumbnail51 from "../img/video-youtube/video-thumbnail51.png";
import Thumbnail52 from "../img/video-youtube/video-thumbnail52.png";
import Thumbnail53 from "../img/video-youtube/video-thumbnail53.png";
import Thumbnail54 from "../img/video-youtube/video-thumbnail54.png";
import Thumbnail55 from "../img/video-youtube/video-thumbnail55.png";
import Thumbnail56 from "../img/video-youtube/video-thumbnail56.png";
import Thumbnail57 from "../img/video-youtube/video-thumbnail57.png";
import Ra1 from "../img/inner/ra/ra1.png";
import Ra2 from "../img/inner/ra/ra2.png";
import Ra3 from "../img/inner/ra/ra3.png";
import Ra4 from "../img/inner/ra/ra4.png";
import Ra5 from "../img/inner/ra/ra5.png";
import Ra6 from "../img/inner/ra/ra6.jpg";
import Ra7 from "../img/inner/ra/ra7.jpg";
import { useHistory } from "react-router-dom";

const LibraryPage = () => {
  const history = useHistory();
  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <div
            onClick={() => history.goBack()}
            className="icon_left d-flex align-items-center"
          >
            <img src={BackButton} alt="img" className="img-fluid" />
            <span className="head_title">Library</span>
          </div>
        </div>
      </header>

      <div className="body_content">
        <div className="inner_body">
          <div className="library_block">
            <div className="mobile_innercontent" id="mobile_innercontent">
              <div className="accordion" id="accordionExample">
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="false"
                      aria-controls="collapseOne"
                    >
                      Ankylosing spondylitis
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      {/* <!-- START FOR > SECTION SYMPTOMS & CAUSES --> */}
                      <section
                        className="section_padding section_one"
                        id="section_one"
                      >
                        <h3 className="subheadtitle">Symptoms & Causes</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc1"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc2"
                            >
                              Symptoms
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc3"
                            >
                              Causes
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc4"
                            >
                              Complications
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc1"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Ankylosing spondylitis is an autoimmune
                                inflammatory disease. The immune system attacks
                                the joints of the spine & pelvis. This leads to
                                inflammation & pain in these joints. Over time,
                                this leads to excessive deposition of calcium &
                                fusion of the joints. This makes the spine less
                                flexible and can result in a hunched-forward
                                posture. If joints that the ribs have with the
                                spine are affected, it can make deep breathing
                                difficult & painful.
                              </p>
                              <p className="desc">
                                Ankylosing spondylitis tends to affect men more
                                often than women. Signs and symptoms typically
                                begin in early adulthood. It can also affect
                                joints other than the spine like knee, ankle,
                                shoulder. At times, the inflammation also can
                                occur in other parts of your body especially the
                                eyes.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div
                                  className="list_video_slider "
                                  data-ride="carousel"
                                >
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo1"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail01}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What is Ankylosing Spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo2"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail02}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What is Ankylosing Spondylitis & how
                                        does it progress?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo3"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail03}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Ankylosing spondylitis & axial
                                        SpondyloArthritis: what is the
                                        difference?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc2"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Early symptoms of ankylosing spondylitis include
                                pain and stiffness in lower back, buttocks and
                                hips. This pain is more in the night & increases
                                with rest. The pain quite often awakens one from
                                sleep particularly in the second half of sleep.
                                One can also have stiffness in the back on
                                getting up that takes 2-3 hours to settle. Neck
                                pain and fatigue also are common. The pain may
                                change locations & affects different parts of
                                the back/ neck & may alternate from one buttock
                                to the other.
                              </p>
                              <p className="desc">
                                The joints & areas most commonly affected are:
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    The joint beneath the buttocks (buttock
                                    pain)
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    The joints of the vertebrae (backache)
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    The joints that the ribs have with the
                                    vertebrae (pain while taking deep breath)
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    The places where tendons and ligaments
                                    attach to bones, mainly in the spine, but
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    sometimes along the back of your heel & the
                                    heel itself (heel pain, pain behind the
                                    ankle)
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    The cartilage between your breastbone and
                                    ribs (chest pain)
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Other joints including the hip, shoulder,
                                    ankles.
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo10"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail10}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Do you have Ankylosing spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo11"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail11}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What is Ankylosing Spondylitis & how
                                        does it progress?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo12"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail12}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Various types of pelvic pain caused by
                                        ankylosing spondylitis
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo13"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail13}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        {" "}
                                        In AS, why is backache worse during the
                                        night or early morning?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo14"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail14}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Why is it painful to cough and sneeze
                                        when you have AS?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo15"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail15}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What causes foot ache in AS?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc3"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Ankylosing spondylitis is an autoimmune
                                condition & the exact cause of this autoimmunity
                                is not known. Genetic factors seem to be
                                involved & it tends to run in families. People
                                who have a gene called HLA-B27 are at a greatly
                                increased risk of developing ankylosing
                                spondylitis. There are other genes too that are
                                involved in the causation of ankylosing
                                spondylitis. So, one can get ankylosing
                                spondylitis without the HLA B27 gene being
                                present. At the same time, every person with the
                                HLA B27 gene need to develop ankylosing
                                spondylitis. Only some people with the gene
                                develop the condition.
                              </p>
                              <p className="desc">Risk factors</p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Sex - Men are more likely to develop
                                    ankylosing spondylitis than are women.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Age — Onset generally occurs in late
                                    adolescence or early adulthood.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Your heredity. Almost 80-90% of those who
                                    have ankylosing spondylitis have the HLA-B27
                                    gene. However, many people who have this
                                    gene never develop ankylosing spondylitis.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Smoking- smoking is linked to a more rapidly
                                    progressive ankylosing spondylitis. It has
                                    been linked with more fusion & progression.
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo16"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail16}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Does everyone with the HLA B27 gene have
                                        AS?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo17"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail17}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Does smoking affect ankylosing
                                        spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc4"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                In ankylosing spondylitis, over a period of
                                time, calcium gets deposited & new bone forms as
                                part of the body's attempt to heal. This bridges
                                the gap between vertebrae and eventually fuses
                                sections of vertebrae. Those parts of the spine
                                become stiff and inflexible. Fusion can also
                                affect the joints that ribs have with the
                                vertebrae thus restricting deep breathing.
                              </p>
                              <p className="desc">
                                Uncontrolled inflammation of ankylosing
                                spondylitis can damage the cartilage of the
                                joints particularly the hip. This leads to
                                osteoarthritis of the hip.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo18"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail18}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Why does the hip pain with ankylosing
                                        spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                <strong>
                                  Other complications might include
                                </strong>
                              </p>
                              <p className="desc">
                                <strong>Eye inflammation (uveitis)</strong> At
                                times, the autoimmune process of ankylosing
                                spondylitis tends to attack the eyes. This leads
                                to uveitis & can cause eye pain, sensitivity to
                                light and blurred vision.{" "}
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo19"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail19}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Uveitis: How does ankylosing spondylitis
                                        affect the eyes?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo20"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail20}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        क्या Ankylosing spondylitis आखों पर असर
                                        करता है? यूवैतिस (uveitis) क्या होता है?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Compression fractures</strong> Despite
                                the excessive calcium deposition, the bones of
                                the vertebrae are often weak. Weakened vertebrae
                                can fracture. This can happen with minor jerks &
                                at times with bending or lifting weights. This
                                can cause sudden increase in the pain. Vertebral
                                fractures can put pressure on and possibly
                                injure the spinal cord and the nerves that pass
                                through the spine.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo21"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail21}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Sudden severe pain in the back with
                                        AS...what could be the reason?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Heart problems</strong> A 2015 review of
                                studies did show that people living with AS had
                                a significantly higher chance of developing
                                coronary artery disease & heart attacks as
                                compared to the general population. (Ungprasert
                                P, Srivali N, Kittanamongkolchai W. Risk of
                                coronary artery disease in patients with
                                ankylosing spondylitis: a systematic review and
                                meta-analysis. Ann Transl Med. 2015;3(4):51.)
                                This is possibly due to the long term effect of
                                the inflammation on the heart. Ankylosing
                                spondylitis can also cause inflammation aorta,
                                the largest artery in the body. The inflamed
                                aorta can distort the shape of the aortic valve
                                in the heart, which impairs its function.
                              </p>
                              <p className="desc">
                                <strong>Pregnancy</strong> Ankylosing
                                spondylitis doesn't appear to affect fertility
                                of one’s chances of getting pregnant. Majority
                                of the women with ankylosing spondylitis are
                                able to safely deliver a healthy baby. Some
                                medications such as nonsteroidal
                                anti-inflammatory drugs (NSAIDs) — may not be
                                safe to use during pregnancy. Backache, pelvic
                                pain & the spinal fusion may pose a challenge
                                during delivery. Proper planning & prior
                                discussion with a rheumatologist can take care
                                of these issues.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo22"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail22}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How to plan pregnancy with Ankylosing
                                        Spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION SYMPTOMS & CAUSES --> */}

                      {/* <!-- START FOR > SECTION DIAGNOSIS --> */}
                      <section
                        className="section_padding section_two"
                        id="section_two"
                      >
                        <h3 className="subheadtitle">Diagnosis</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc25"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc26"
                            >
                              Radiology tests
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc27"
                            >
                              Lab tests
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc25"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                A rheumatologist suspects ankylosing spondylitis
                                if one has inflammatory backache. Inflammatory
                                backache would mean backache that is worse after
                                rest & at night & that improves with activity.
                                During the physical exam, mobility of the spine
                                (neck, mid back & lower back) is checked. Pain
                                on pressing the buttocks, flexing the thighs at
                                the hip would be checked. Chest expansion would
                                be looked at as ankylosing spondylitis restricts
                                the same.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo4"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail04}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How do we diagnose Ankylosing
                                        spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc26"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>X-rays</strong> allow your doctor to
                                check for changes in your sacroiliac joints &
                                the joints of the vertebrae. However, Xray does
                                not pick active inflammation but picks up the
                                damage caused to the joints due to the
                                inflammation & the calcification. Hence Xray
                                picks up changes late in the course of
                                ankylosing spondylitis.{" "}
                              </p>
                              <p className="desc">
                                An <strong>MRI</strong> shows active
                                inflammation as well as damage to the joints. It
                                can show inflammation in the sacroiliac joints,
                                vertebral joints & the joints that ribs make
                                with the vertebrae. MRI can pick up the
                                inflammation early & help with an early
                                diagnosis.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo23"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail23}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What reports can confirm diagnosis of
                                        ankylosing spondylitis? Is it the Xray/
                                        HLA B27/ MRI?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc27"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>HLA B 27 test</strong> this is a blood
                                test
                              </p>
                              <p className="desc">
                                <strong>
                                  HLA B27 is a gene that is strongly associated
                                  with ankylosing spondylitis.
                                </strong>{" "}
                                It is seen in almost 90% patients suffering from
                                ankylosing spondylitis. However there are other
                                genes that can cause ankylosing spondylitis as
                                well & one can have AS without having the HLA
                                B27 gene. HLA B27 gene is inherited from parents
                                & having the gene does not necessarily mean that
                                one would end up having ankylosing spondylitis.
                              </p>
                              <p className="desc">
                                <strong>ESR & CRP</strong> these tests indicate
                                inflammatory process in the body & help assess
                                the activity of ankylosing spondylitis. CRP is
                                repeated on followup visits & helps keep a track
                                of the AS activity.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo24"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail24}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How do we diagnose Ankylosing
                                        spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo23"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail23}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What reports can confirm diagnosis of
                                        ankylosing spondylitis? Is it the Xray/
                                        HLA B27/ MRI?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo25"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail25}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Is HLA B27 necessary for a diagnosis of
                                        ankylosing spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo26"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail26}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        क्या Ankylosing spondylitis के लिए HLA
                                        B27 का पॉज़िटिव होना ज़रूरी है?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION DIAGNOSIS --> */}

                      {/* <!-- START FOR > SECTION TREATMENT --> */}
                      <section
                        className="section_padding section_three"
                        id="section_three"
                      >
                        <h3 className="subheadtitle">Treatment</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc8"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc9"
                            >
                              Medications
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc10"
                            >
                              Physiotherapy
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc11"
                            >
                              Diet
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc12"
                            >
                              Healthy lifestyle
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc8"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                There's no cure for ankylosing spondylitis, but
                                treatment is available to control the arthritis
                                & prevent progression as well as the
                                complications. Treatment can help delay or
                                prevent the process of the spine fusion and
                                stiffening.
                              </p>
                              <p className="desc">
                                Ankylosing spondylitis treatment is most
                                successful early in the disease course before
                                the disease causes irreversible damage to your
                                joints.
                              </p>
                            </div>
                            <div className="video_block">
                              <h4 className="maintitle">Related Video</h4>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo5"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail05}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How to conquer ankylosing spondylitis? :
                                        A systematic practical plan.
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo6"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail06}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Ankylosing spondylitis को जीतने के १०
                                        नियम
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo7"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail07}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Can we reverse vertebral fusion related
                                        to Ankylosing Spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc9"
                          >
                            <div className="vertical_tab_content d-flex align-items-start flex-column flex-md-row">
                              <div
                                className="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 nav flex-column nav-pills me-3"
                                id="v-pills-tab"
                              >
                                <Link
                                  to="#"
                                  className="nav-link active"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications1"
                                >
                                  NSAIDs
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications2"
                                >
                                  DMARDs
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications3"
                                >
                                  Biologics
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications4"
                                >
                                  Stem Cell Therapy
                                </Link>
                              </div>
                              <div
                                className="col-12 col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 tab-content lib-content"
                                id="v-pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  id="medications1"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      Nonsteroidal anti-inflammatory drugs
                                      (NSAIDs) such as naproxen (Naprosyn),
                                      indomethacin (Indocin, Indocid),
                                      etoricoxib (Retoz, etoshine) are the
                                      medications doctors most commonly use to
                                      treat ankylosing spondylitis. As the name
                                      suggests, they reduce the inflammation in
                                      the joints. Contrary to popular belief
                                      they are not just 'pain killers' but have
                                      a strong 'anti-inflammatory' function. The
                                      do reduce the inflammation associated with
                                      AS. They are used for prolonged period in
                                      AS to control the inflammation.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo27"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail27}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Ankylosing spondylitis treatment:
                                              Are NSAIDs useful?
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo28"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail28}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What is the difference between
                                              traditional & COX-2 selective
                                              NSAIDs?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      However, these medications can cause
                                      acidity, gastrointestinal bleeding, kidney
                                      issues. A rheumatologist would keep a
                                      watch on these possibilities during the
                                      treatment.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo29"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail29}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              NSAIDs (pain killers) for
                                              Ankylosing Spondylitis: 10
                                              precautions to avoid side effects
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      <strong>Streoids</strong> Steroids are
                                      used as a short term treatment to manage a
                                      flare up of ankylosing spondylitis. But
                                      steroids have no long term use in treating
                                      Ankylosing spondylitis.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo30"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail30}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Ankylosing spondylitis: क्या
                                              NSAIDs (दर्द शामक ) गोलियाँ लेकर
                                              AS अच्छा हो सकता है?
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo31"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail31}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Ankylosing spondylitis: कौनसा
                                              NSAID (दर्द शामक गोली) AS के लिए
                                              सबसे अच्छा है ?
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo32"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail32}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              10 सावधानिया NSAIDs (दर्द शामक
                                              गोलीया) की दुष्प्रभाव को रोकने के
                                              लिए
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="medications2"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      <strong>Sulphasalazine</strong>{" "}
                                      Sulphasalazine (Saaz, Sazo) is used by
                                      many rheumatologists for ankylosing
                                      spondylitis. Though there is no conclusive
                                      study about its effectiveness in reducing
                                      the backache of AS, it has been used
                                      traditionally. Many rheumatologist believe
                                      that it does help reduce the backache of
                                      AS.
                                    </p>
                                    <p className="desc">
                                      Sulphasalazine & methotrexate are useful
                                      in reducing the inflammation of peripheral
                                      joints (knee, ankle, hand joints)
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo33"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail33}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Ankylosing spondylitis: Know your
                                              medications: DMARDs
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo34"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail34}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Ankylosing spondylitis: कौनसी दवाई
                                              से अच्छा होता है? Sulphasalazine
                                              (साज/ साजों ) और अन्य DMARDs
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo35"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail35}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              क्या sulphasalzine (Saaz/ Sazo/
                                              साज/ साजो) गोली पुरुषों में प्रजनन
                                              क्षमता को प्रभावित करती है?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="medications3"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      If one’s backache persists despite NSAIDs
                                      & regular exercises, then biologics are
                                      thought of. Biologics include tumor
                                      necrosis factor (TNF) blocker or an
                                      interleukin-17 (IL-17) inhibitor. TNF
                                      blockers target a chemical called TNF
                                      alpha that is produced in the body &
                                      responsible for inflammation associated
                                      with ankylosing spondylitis. IL-17 is
                                      another chemical produced in the body & is
                                      associated with inflammation of ankylosing
                                      spondylitis.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo36"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail36}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What are biologics? How do they
                                              reduce inflammation in ankylosing
                                              spondylitis?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      These chemicals (TNF alpha & IL-17 play a
                                      role in maintaining body’s immune defense
                                      & taking biologics that block these
                                      chemicals can increase one’s chances of
                                      infections. One is investigated thoroughly
                                      prior to staring a biologics to minimize
                                      the chances of infections later. In India,
                                      there is a particular concern about
                                      Tuberculosis. One is investigated for
                                      latent tuberculosis prior to starting
                                      biologics. One should take proper
                                      precautions while on biologics to reduce
                                      the possibility of catching an infection.{" "}
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo37"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail37}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Do Biologics cause Tuberculosis?
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo38"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail38}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What precaution should one take to
                                              avoid infections while on
                                              biologics?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      If one is unable to take TNF blockers or
                                      IL-17 inhibitors because of other health
                                      conditions, a rheumatologist may recommend
                                      the Janus kinase inhibitor tofacitinib
                                      (Xeljanz). This drug has been approved for
                                      psoriatic arthritis and rheumatoid
                                      arthritis. Studies have shown its
                                      effectiveness in ankylosing spondylitis as
                                      well. Research is ongoing & its approval
                                      for ankylosing spondylitis is awaited.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo39"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail39}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Tofacitinib: the promising new
                                              therapy for ankylosing spondylitis
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo40"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail40}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Tofacitinib for ankylosing
                                              spondylitis- side effects &
                                              precautions
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo41"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail41}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              टोफ़ासितिनिब (Tofacitinib) गोली :
                                              आशा की नई किरण ankylosing
                                              spondylitis के लिए
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo42"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail42}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              टोफ़ासिटिनिब - जानिए एहतियात और
                                              साइड इफेक्ट्स के बारे में
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      Many patients feel that biologics are the
                                      only treatment options for ankylosing
                                      spondylitis. However, many patients
                                      suffering from ankylosing spondylitis,
                                      particularly in the early stage improve
                                      with NSAIDs & regular back exercises. Each
                                      & every person may not require a biologic
                                      therapy.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo43"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail43}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Does every Ankylosing spondylitis
                                              warrior require biologic therapy?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="medications4"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      Ankylosing spondylitis is an autoimmune
                                      ailment. One’s own immunity thinks that
                                      joints are foreign & attacks the joints
                                      causing inflammation. What if one can
                                      transplant this immunity just the way one
                                      does a transplant of the kidney, heart?
                                      This is the concept behind stem cell
                                      therapy. If the entire immune system that
                                      has started working against one’s own
                                      joints can be removed & replaced by a
                                      healthy immune system that would not
                                      attack the joints; ankylosing spondylitis
                                      can be cured. Stem cell therapy is being
                                      researched & not being used as a regular
                                      therapy currently for ankylosing
                                      spondylitis.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo57"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail57}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What is stem cell therapy? Is it
                                              useful in ankylosing spondylitis?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc10"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Physical therapy is an integral part of
                                treatment of ankylosing spondylitis. Exercises
                                can help reduce the pain, maintain flexibility
                                of the spine & retard fusion.
                              </p>
                              <p className="desc">
                                Range-of-motion and stretching exercises can
                                help maintain flexibility of the back & and
                                preserve good posture. Proper sleeping and
                                walking positions and back exercises can help
                                prevent the hunch back posture.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo44"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail44}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Stretches & exercises for Ankylosing
                                        Spondylitis
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                NSAIDs & regular exercises can induce remission
                                in early ankylosing spondylitis. However,
                                exercises alone may not be sufficient to control
                                the arthritis & medications are also necessary.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo45"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail45}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Can physiotherapy & exercise cure
                                        ankylosing spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                While exercising, one has to be careful not to
                                put undue pressure on the spine. High impact
                                exercises like jumping, skipping can put undue
                                pressure on the spine & aggravate the backache.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo46"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail46}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Exercises to be avoided in ankylosing
                                        spondylitis
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo47"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail47}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Ankylosing Spondylitis में कौनसे व्यायाम
                                        नहीं करने चाहिए ?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc11"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Dr. Alan Ebringer proposed a theory that
                                explained causation of AS & a possible dietary
                                remedy. He proposed that klebsiella, a type of
                                bacteria in one’s gut is responsible for AS.
                                This bacteria feeds on starch & can be starved
                                to death with a low starch diet. This lead to
                                the ‘low starch or London AS diet”. Many AS
                                patients do find relief in their symptoms with
                                this diet. Dietary studies are difficult to
                                conduct & the effectiveness of this dietary
                                intervention has not been scientifically
                                conclusively established.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo48"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail48}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Low starch diet & ankylosing
                                        spondylitis: Part 1: scientific evidence
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo49"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail49}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Low starch diet for Ankylosing
                                        Spondylitis | Part 2: All you need to
                                        know.
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo50"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail50}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Ankylosing spondylitis & low starch diet
                                        | Part 3: diet charts & plans
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo51"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail51}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        Low starch diet & ankylosing spondylitis
                                        | Part 4: What are the possible hazards?
                                        How to overcome?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo52"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail52}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        क्या पेट और खानपान का एससे कोई सम्बंध
                                        है?
                                      </h3>
                                    </div>
                                  </div>
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo53"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail53}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        लो स्टार्च डाइयट का पालन कैसे कर सकते है
                                        ? दिनभर आहार कैसे ले?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc12"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Apart from the medicines & exercises, lifestyle
                                changes do help relieve symptoms of ankylosing
                                spondylitis. A good sleep can help reduce the
                                pain & fatigue associated with ankylosing
                                spondylitis.
                              </p>
                              <p className="desc">
                                A good mattress would help improve the quality
                                of sleep.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo54"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail54}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How to choose the right mattress for
                                        Ankylosing Spondylitis?
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                Sleeping posture can help maintain the correct
                                posture & avoid the hunch back deformity in the
                                long run. ‘Prone lying’ is one of the best
                                sleeping postures for someone with ankylosing
                                spondylitis. This helps keep the spine straight
                                & reduces chances of hunchback deformity.{" "}
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo55"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail55}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        What is the best sleeping posture for
                                        ankylosing spondylitis?{" "}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                Apart from pain, fatigue is also one of the
                                common problem for one suffering from ankylosing
                                spondylitis. This may be caused due to the
                                inflammation of ankylosing spondylitis or
                                fibromyalgia that often accompanies AS. Adequate
                                control of AS, fibromyalgia & lifestyle changes
                                can help one take care of the fatigue.
                              </p>
                            </div>
                            <div className="video_block">
                              <h2 className="maintitle">Related Video</h2>
                              <div className="list_video mobile_list_video horizontal-scrollable">
                                <div className="list_video_slider">
                                  <div
                                    className="box_video small_height"
                                    data-bs-toggle="modal"
                                    data-bs-target="#modalvideo56"
                                  >
                                    <div className="thumbnail">
                                      <span className="icon">
                                        <img
                                          src={YtIcon}
                                          alt=""
                                          className="img-fluid"
                                        />
                                      </span>
                                      <img
                                        src={Thumbnail56}
                                        alt=""
                                        className="img-fluid"
                                      />
                                    </div>
                                    <div className="caption">
                                      <h3 className="subheadtitle">
                                        How to conquer the fatigue of ankylosing
                                        spondylitis?{" "}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION TREATMENT --> */}

                      {/* <!-- START FOR > SECTION SUCCESS STORIES --> */}
                      <section
                        className="section_padding section_four"
                        id="section_four"
                      >
                        <h3 className="subheadtitle">Success Stories</h3>
                        <div className="video_block">
                          <div className="list_video mobile_list_video horizontal-scrollable">
                            <div className="list_video_slider">
                              <div
                                className="box_video big_height"
                                data-bs-toggle="modal"
                                data-bs-target="#modalvideo8"
                              >
                                <div className="thumbnail">
                                  <span className="icon">
                                    <img
                                      src={YtIcon}
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </span>
                                  <img
                                    src={Thumbnail08}
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                                <div className="caption">
                                  <h3 className="subheadtitle">
                                    How can you conquer ankylosing spondylitis?
                                  </h3>
                                </div>
                              </div>
                              <div
                                className="box_video big_height"
                                data-bs-toggle="modal"
                                data-bs-target="#modalvideo9"
                              >
                                <div className="thumbnail">
                                  <span className="icon">
                                    <img
                                      src={YtIcon}
                                      alt=""
                                      className="img-fluid"
                                    />
                                  </span>
                                  <img
                                    src={Thumbnail09}
                                    alt=""
                                    className="img-fluid"
                                  />
                                </div>
                                <div className="caption">
                                  <h3 className="subheadtitle">
                                    10 rules to conquer ankylosing spondylitis
                                  </h3>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION SUCCESS STORIES --> */}
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      Rheumatoid arthritis
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      {/* <!-- START FOR > SECTION SYMPTOMS & CAUSES --> */}
                      <section
                        className="section_padding section_one"
                        id="section_one"
                      >
                        <h3 className="subheadtitle">Symptoms & Causes</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc111"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc22"
                            >
                              Symptoms
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc33"
                            >
                              Causes
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc44"
                            >
                              Complications
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc111"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Rheumatoid Arthritis is an autoimmune disease
                                affecting the joints. Normally, body’s immune
                                system is designed to fight organisms causing
                                infections. Due to various reasons, the immune
                                system may start considering its own body organs
                                as foreign and attacks it. This self intolerance
                                is known as autoimmunity. The condition it
                                results into is called as autoimmune disease.
                              </p>
                              <p className="desc">
                                To understand the cause of joint swelling in
                                Rheumatoid Arthritis, let us first understand
                                the structure of a synovial joint. A joint is
                                made up of two bones. It is lined on the inner
                                side by a protective lining called the synovium.
                              </p>
                            </div>
                            <div className="imgthumbnail_block">
                              <div className="row d-flex align-items-center mb-2">
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 gridcol">
                                  <div className="wallpaper_block">
                                    <img
                                      src={Ra1}
                                      alt=""
                                      className="img-fluid img_fit"
                                    />
                                  </div>
                                </div>
                                <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-12 gridcol">
                                  <div className="desc_block">
                                    <p className="desc">
                                      This synovium is the target of immune
                                      attack & gets swollen. To begin with the
                                      swelling is mild. Hence it is not very
                                      obvious from outside. HOwever, it does
                                      cause pain & stiffness of the joint.
                                      Later, as the swelling increases, it
                                      becomes clearly visible externally as
                                      well.l.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="imgthumbnail_block">
                              <div className="row d-flex align-items-center mb-2">
                                <div className="col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-12 gridcol">
                                  <div className="desc_block">
                                    <p className="desc text-md-end">
                                      TThe swollen synovium in Rheumatoid
                                      Arthritis has destructive potential. If
                                      not treated, it begins damaging the
                                      underlying bones & cartilage. This damage
                                      involving the bones, cartilage and
                                      surrounding muscles leads to deformities.
                                    </p>
                                  </div>
                                </div>
                                <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-12 gridcol">
                                  <div className="wallpaper_block">
                                    <img
                                      src={Ra2}
                                      alt=""
                                      className="img-fluid img_fit"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc22"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Rheumatoid arthritis causes pain & swelling in
                                multiple joints. It commonly affects the joints
                                of the hands (knuckles and the first joint of
                                the fingers) & feet. The wrist, elbow, shoulder,
                                knee, and ankle can also be affected. Initially,
                                a person may not experience obvious swelling in
                                the said joints. However, there is pain &
                                stiffness of these joints early in the morning.
                                The stiffness settles after a hot water bath or
                                as the joints are used. Later, as arthritis
                                progresses, the swelling becomes obvious. One
                                may also develop nodular swelling called
                                rheumatoid nodules. These are commonly seen on
                                the forearm below the elbow joint.
                              </p>
                            </div>
                            <div className="imgthumbnail_block">
                              <div className="row d-flex align-items-end mb-2">
                                <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12 gridcol">
                                  <div className="wallpaper_block">
                                    <img
                                      src={Ra3}
                                      alt=""
                                      className="img-fluid img_fit"
                                    />
                                  </div>
                                  <span className="txt_caption">
                                    Rheumatoid Arthritis Swelling Of Hand Joints
                                  </span>
                                </div>
                                <div className="col-xxl-7 col-xl-7 col-lg-7 col-md-7 col-12 gridcol">
                                  <div className="wallpaper_block">
                                    <img
                                      src={Ra4}
                                      alt=""
                                      className="img-fluid img_fit"
                                    />
                                  </div>
                                  <span className="txt_caption">
                                    Rheumatoid Arthritis Swelling Of knee
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="imgthumbnail_block">
                              <div className="row d-flex align-items-end mb-2">
                                <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12 gridcol">
                                  <div className="wallpaper_block">
                                    <img
                                      src={Ra5}
                                      alt=""
                                      className="img-fluid img_fit"
                                    />
                                  </div>
                                  <span className="txt_caption">
                                    Rheumatoid Nodule.
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc33"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Rheumatoid arthritis is an autoimmune condition
                                & the exact cause of this autoimmunity is not
                                known. Genetic factors seem to be involved & it
                                tends to run in families. However one can suffer
                                from rheumatoid arthritis without any family
                                member suffering from it.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc44"
                          >
                            <div className="summary_block">
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Deformities - if not taken care of,
                                    rheumatoid arthritis can lead to disabling
                                    hand/ feet deformities in the long run. It
                                    is also important to note that if properly
                                    treated, deformities are uncommon.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Osteoporosis- rheumatoid arthritis itself &
                                    steroids that are used to treat it can make
                                    the bones weak & fragile. This increase the
                                    risk of fractures.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Eye complications- rheumatoid arthritis
                                    inflammation can affect the eyes causing
                                    scleritis/ episcleritis. Scleritis
                                    ((inflammation of the white part of the eye)
                                    is a serious condition & can cause vision
                                    loss.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Lung complications- interstitial lung
                                    disease- rheumatoid arthritis can cause
                                    immune attack on the lung & consequent
                                    stiffening of the lungs.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION SYMPTOMS & CAUSES --> */}

                      {/* <!-- START FOR > SECTION DIAGNOSIS --> */}
                      <section
                        className="section_padding section_two"
                        id="section_two"
                      >
                        <h3 className="subheadtitle">Diagnosis</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc55"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc66"
                            >
                              Radiology tests
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc77"
                            >
                              Lab tests
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc55"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                A rheumatologist suspects rheumatoid arthritis
                                if one has multiple inflamed joints. Inflamed
                                joints are characterized by pain & swelling.
                                Rheumatologist will take your history & examine
                                your joints. A diagnosis of Rheumatoid arthritis
                                is based on the swelling in the joints & the
                                pattern of the joints involved. There are other
                                causes of inflamed joints as well & blood
                                investigations, Xrays can help differentiate
                                between them.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc66"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>X-rays</strong> allow your doctor to
                                check for changes in your joints. X rays of the
                                joints do show characteristic changes & help
                                confirm the diagnosis of Rheumatoid arthritis.
                                The characteristic changes include bone loss at
                                the edges of the bone (erosions) & loss of joint
                                cartilage (space).
                              </p>
                              <p className="desc">
                                X rays are often normal in early stages of
                                Rheumatoid arthritis & do not help much in
                                diagnosing rheumatoid arthritis at an early
                                stage.
                              </p>
                              <p className="desc">
                                <strong>Sonography/ MRI</strong> Sonography/ MRI
                                can show the thickened synovium (joint lining)
                                in the joints & confirm the diagnosis of
                                rheumatoid arthritis. Sonography/ MRI help to
                                diagnose Rheumatoid arthritis early.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc77"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Rheumatoid factor</strong> this is a
                                blood test This is a common investigation asked
                                when rheumatoid arthritis is suspected.
                                Rheumatoid factor is a protein produced by our
                                immune system. High levels of rheumatoid factor
                                are seen in rheumatoid arthritis. However, a few
                                patients of rheumatoid arthritis may have normal
                                levels of rheumatoid factor while some normal
                                individuals may have high levels of rheumatoid
                                factor. So, rheumatoid factor test is not
                                diagnostic of rheumatoid arthritis & absence of
                                rheumatoid factor does not always mean absence
                                of rheumatoid arthritis.
                              </p>
                              <p className="desc">
                                <strong>Anti CCP antibody</strong> this is a
                                blood test Anti CCP antibody stands for
                                anti-cyclic citrullinated peptide antibody. It
                                is a protein produced by our immune system & is
                                highly suggestive of rheumatoid arthritis. This
                                is a very reliable test for rheumatoid arthritis
                                & is better than rheumatoid factor in diagnosing
                                rheumatoid arthritis (Diagnostic Accuracy of
                                Anti–Cyclic Citrullinated Peptide Antibody and
                                Rheumatoid Factor for Rheumatoid Arthritis K.
                                Nishimura, D. Sugiyama, Y. Kogata, G. Tsuji, T.
                                Nakazawa, S. Kawano, K. Saigo, A. Morinobu, M.
                                Koshiba, K. M. Kuntz, I. Kamae and S. Kumagai
                                Ann Intern Med 2007; 797-808 ). High levels of
                                the Anti CCP antibody does indicate a more
                                aggressive RA & higher risk of joint damage as
                                compared to a patient with low levels. (Kastbom,
                                A., Strandberg, G., Lindroos, A. et al. 2004.
                                Anti-CCP antibody test predicts the disease
                                course during 3 years in early rheumatoid
                                arthritis (the Swedish TIRA project). Ann.
                                Rheum. Dis.,63:1085–9.) Anti CCP antibody may be
                                negative in a few individuals with rheumatoid
                                arthritis & a negative test does not rule out
                                rheumatoid arthritis.
                              </p>
                              <p className="desc">
                                <strong>ESR & CRP</strong> these are blood test
                                ESR/ CRP are blood tests to measure the
                                inflammation in the body. Arthritis patients
                                have high ESR & CRP due to the ongoing
                                inflammation in the joints. However, arthritis
                                is not the only condition associated with high
                                ESR/ CRP. Infections, other autoimmune diseases
                                will also lead to a high ESR/ CRP. It is best
                                left to the doctor to interpret the ESR/ CRP
                                result.
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION DIAGNOSIS --> */}

                      {/* <!-- START FOR > SECTION TREATMENT --> */}
                      <section
                        className="section_padding section_three"
                        id="section_three"
                      >
                        <h3 className="subheadtitle">Treatment</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc18"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc19"
                            >
                              Medications
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc20"
                            >
                              Physiotherapy
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc21"
                            >
                              Diet
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc18"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Effective therapy is available for rheumatoid
                                arthritis. DMARDs (Disease modifying anti
                                rheumatic drugs) & if required biologics can
                                control the inflammation of joints & prevent
                                joint deformities. Rheumatoid arthritis is best
                                treated early before it causes any damage to the
                                joints.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc19"
                          >
                            <div className="vertical_tab_content d-flex align-items-start flex-column flex-md-row">
                              <div
                                className="col-12 col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 nav flex-column nav-pills me-3"
                                id="v-pills-tab"
                              >
                                <Link
                                  to="#"
                                  className="nav-link active"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications11"
                                >
                                  NSAIDs
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications12"
                                >
                                  DMARDs
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications13"
                                >
                                  Biologics
                                </Link>
                                <Link
                                  to="#"
                                  className="nav-link"
                                  data-bs-toggle="pill"
                                  data-bs-target="#medications14"
                                >
                                  Steroids
                                </Link>
                              </div>
                              <div
                                className="col-12 col-xxl-9 col-xl-9 col-lg-9 col-md-9 col-sm-12 tab-content lib-content"
                                id="v-pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade show active"
                                  id="medications11"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      NSAIDS stands for Non Steroidal Anti
                                      Inflammatory Drugs- NSAIDs reduce the
                                      inflammation & the pain associated with
                                      rheumatoid arthritis. NSAIDs are not used
                                      in the long run. They are used in the
                                      initial phases till the DMARDs control the
                                      arthritis activity & later during a flare.
                                    </p>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="medications12"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      DMARDs stands for Disease Modifying Anti
                                      Rheumatic Drugs These include-
                                      Methotrexate, Hydroxychloroquine,
                                      Sulphasalazine, Leflunomide These are the
                                      main medications for rheumatoid arthritis
                                      & are used in the long run to control the
                                      arthritis activity. They are effective
                                      agents & control the rheumatoid arthritis
                                      activity in the long run.
                                    </p>
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="medications13"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      Biologics are genetically engineered
                                      proteins. They act on specific chemicals
                                      that control the inflammatory process.
                                    </p>
                                    <p className="desc">
                                      Many biologics are available for
                                      rheumatoid arthritis. They include–
                                    </p>
                                    <ul className="list-unstyled list_bullet ms-3">
                                      <li>
                                        <span className="desc">
                                          TNF alpha blockers- Infliximab,
                                          Etanercept, Adalimumab, Golimumab,
                                          Sertolizumab
                                        </span>
                                      </li>
                                      <li>
                                        <span className="desc">
                                          IL-6 blockers- Tocilizumab
                                        </span>
                                      </li>
                                      <li>
                                        <span className="desc">
                                          B cell blocker- Rituximab
                                        </span>
                                      </li>
                                      <li>
                                        <span className="desc">
                                          T cell inhibitor- Abatacept
                                        </span>
                                      </li>
                                      <li>
                                        <span className="desc">
                                          IL-1 blocker- Anakinra
                                        </span>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo36"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail36}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What are biologics? How do they
                                              reduce inflammation in ankylosing
                                              spondylitis?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="summary_block">
                                    <p className="desc">
                                      If rheumatoid arthritis remains active
                                      despite DMARDs, then biologics are thought
                                      of. Biologics do block chemicals involved
                                      in immune processes & can increase one’s
                                      chances of infections. One is investigated
                                      thoroughly prior to starting a biologics
                                      to minimize the chances of infections
                                      later. In India, there is a particular
                                      concern about Tuberculosis. One is
                                      investigated for latent tuberculosis prior
                                      to starting biologics. One should take
                                      proper precautions while on biologics to
                                      reduce the possibility of catching an
                                      infection.
                                    </p>
                                  </div>
                                  <div className="video_block">
                                    <h4 className="maintitle">Related Video</h4>
                                    <div className="list_video mobile_list_video horizontal-scrollable">
                                      <div className="list_video_slider">
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo37"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail37}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              Do Biologics cause Tuberculosis?
                                            </h3>
                                          </div>
                                        </div>
                                        <div
                                          className="box_video small_height"
                                          data-bs-toggle="modal"
                                          data-bs-target="#modalvideo38"
                                        >
                                          <div className="thumbnail">
                                            <span className="icon">
                                              <img
                                                src={YtIcon}
                                                alt=""
                                                className="img-fluid"
                                              />
                                            </span>
                                            <img
                                              src={Thumbnail38}
                                              alt=""
                                              className="img-fluid"
                                            />
                                          </div>
                                          <div className="caption">
                                            <h3 className="subheadtitle">
                                              What precaution should one take to
                                              avoid infections while on
                                              biologics?
                                            </h3>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="medications14"
                                >
                                  <div className="summary_block">
                                    <p className="desc">
                                      Steroids or glucocorticoids reduce the
                                      inflammation in the joints. They are used
                                      during the initial 4-6 weeks of therapy &
                                      later during a flare. They are generally
                                      not used in the long run for controlling
                                      rheumatoid arthritis.
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc20"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Physical therapy is an integral part of
                                treatment of rheumatoid arthritis. Exercises can
                                help reduce the pain, maintain flexibility of
                                the joints & prevent deformities.
                              </p>
                              <p className="desc">
                                Muscle weakness occurs in muscles around the
                                inflamed joints due reduction in activities.
                                Maintenance of normal muscle strength is
                                important for physical & also for stabilization
                                of the joints and prevention of falls.
                              </p>
                              <p className="desc">
                                <strong>Physiotherapy modalities-</strong>
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Heat/ cold application
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    TENS electrostimulation
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">Hydrotherapy</span>
                                </li>
                                <li>
                                  <span className="desc">Massage therapy</span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Therapeutic exercise
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc21"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Dietary interventions have shown substantial
                                benefits in reducing disease symptoms such as
                                pain, joint stiffness, swelling. One can benefit
                                from avoiding foods that increase inflammation
                                (anti inflammatory diet).
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION TREATMENT --> */}
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Gout
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      {/* <!-- START FOR > SECTION SYMPTOMS & CAUSES --> */}
                      <section
                        className="section_padding section_one"
                        id="section_one"
                      >
                        <h3 className="subheadtitle">Symptoms & Causes</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc45"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc46"
                            >
                              Symptoms
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc47"
                            >
                              Causes
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc48"
                            >
                              Complications
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc45"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Gout is a type of arthritis caused by a buildup
                                of uric acid crystals in the joints. It
                                generally starts as an episodic pain & swelling
                                in the joints, particularly the joints of the
                                great toe & feet. If not taken care of it can
                                cause pain & swelling in other joints as well &
                                has the potential to cause continuous pain in
                                the joints. Over a period of time, if not taken
                                care of it can lead to deformities of the joints
                                & deposition of uric acid under the skin in the
                                form of nodules called as tophi.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc46"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Gout can affect anyone. However men are more
                                likely to be affected & get gout earlier than
                                women. Women tend to get affected after
                                menopause.{" "}
                              </p>
                              <p className="desc">
                                Gout causes epsiodes or attacks of pain &
                                swelling in the joints. An episode can last 3-10
                                days. During an episode, the joint swells up &
                                causes intense pain. In the majority, it starts
                                with the joint of the great toe. In between the
                                acute episodes, one does not have any joint
                                pain. If these symptoms are neglected, gout can
                                become chronic. It can then cause persistent
                                pain & swelling in multiple joints.
                              </p>
                              <div className="imgthumbnail_block">
                                <div className="row d-flex align-items-end mb-2">
                                  <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12 gridcol">
                                    <div className="wallpaper_block">
                                      <img
                                        src={Ra6}
                                        alt=""
                                        className="img-fluid img_fit"
                                      />
                                    </div>
                                    {/* <span className="txt_caption">
                                    Rheumatoid Nodule.
                                  </span> */}
                                  </div>
                                </div>
                              </div>
                              <p className="desc">
                                Uric acid can also get deposited under the skin.
                                These nodules are called tophi. The white colour
                                of the deposited uric acid is often seen under
                                the nodules. They are generally painless but may
                                get inflamed & may ulcerate leading to oozing of
                                the white material (uric acid).
                              </p>
                              <div className="imgthumbnail_block">
                                <div className="row d-flex align-items-end mb-2">
                                  <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-5 col-12 gridcol">
                                    <div className="wallpaper_block">
                                      <img
                                        src={Ra7}
                                        alt=""
                                        className="img-fluid img_fit"
                                      />
                                    </div>
                                    {/* <span className="txt_caption">
                                    Rheumatoid Nodule.
                                  </span> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc47"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Our body makes a chemical called uric acid
                                during breakdown of chemicals called purines.
                                Purines are chemicals that are naturally created
                                in our body & are also present in our food.
                                Generally about 3/4th of the uric acid comes
                                from the breakdown of purines in the body while
                                1/4th comes from the food. Generally the body
                                gets rid of the uric acid in urine. However if
                                the consumption of uric acid increases & the
                                body is not able to get rid of uric acid then
                                this leads to a buildup of uric acid in the
                                blood. This in turn can then cause
                                crystallization of the uric acid crystals in the
                                joints leading to an episode of gout.
                              </p>
                            </div>
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Risk factors</strong>
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Family history A person’s genes can increase
                                    the chances of gout. Genes do determine the
                                    kidney's handling of uric acid. If the
                                    kidney does not excrete uric acid
                                    adequately, a buildup of uric acid in the
                                    body can start.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Obesity obesity increase the chances of
                                    gout. The more overweight one is, higher are
                                    the uric acid levels & higher the chances of
                                    gout.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Gender & age Gout is more common in men than
                                    women. Women rarely get gout before
                                    menopause. Female hormone estrogen increases
                                    the uric acid excretion by the kidneys.
                                    Estrogen levels decrease after menopause &
                                    uric acid levels increase.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    High alcohol/ protein intake - Higher intake
                                    of alcohol/ protein increases the production
                                    of uric acid in the body. This may be more
                                    than what the kidney can handle & lead to
                                    gout.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Medications: certain medications called
                                    diuretics can reduce the ability of the
                                    kidneys to take care of the uric acid & lead
                                    to increase in the blood uric acid levels.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc48"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                If not adequately treated, chronic gout can
                                cause deformities of the joints. The gouty tophi
                                can at times compress nerves.
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION SYMPTOMS & CAUSES --> */}

                      {/* <!-- START FOR > SECTION DIAGNOSIS --> */}
                      <section
                        className="section_padding section_two"
                        id="section_two"
                      >
                        <h3 className="subheadtitle">Diagnosis</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc35"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc36"
                            >
                              Radiology tests
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc37"
                            >
                              Lab tests
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc35"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                A rheumatologist suspects gout if one has
                                episodic pain & swelling of the joints. The
                                suspicion is higher if joints of the feet are
                                affected.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc36"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Xray</strong> An Xray of the feet/
                                swollen joint can show joint damage resulting
                                from long standing gout.
                              </p>
                              <p className="desc">
                                <strong>Synovial fluid examination:</strong>
                                Fluid is aspirated from the swollen joint &
                                examined under a microscope. In case of gout,
                                uric acid crystals can be seen under the
                                microscope. This is a confirmatory test for
                                gout.
                              </p>
                              <p className="desc">
                                <strong>Dual Energy CT (DECT):</strong>
                                This is a special CT scan & can identify uric
                                acid deposition in & around the joints. This is
                                generally used in some cases to confirm the
                                diagnosis of gout.
                              </p>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc37"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                <strong>Uric acid level</strong> This is a blood
                                test. A high uric acid level does suggest gout
                                in the presence of/ history of episodic joint
                                pain/ swelling. However uric acid level can be
                                normal immedicately following an episode of
                                gout.
                              </p>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION DIAGNOSIS --> */}

                      {/* <!-- START FOR > SECTION TREATMENT --> */}
                      <section
                        className="section_padding section_three"
                        id="section_three"
                      >
                        <h3 className="subheadtitle">Treatment</h3>
                        <ul className="customnav nav nav-tabs" id="myTab">
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link active"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc58"
                            >
                              Overview
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc59"
                            >
                              Treatment of the acute attack
                            </Link>
                          </li>
                          <li className="nav-item">
                            <Link
                              to="#"
                              className="nav-link"
                              data-bs-toggle="tab"
                              data-bs-target="#tabsc60"
                            >
                              Long term treatment to prevent attacks
                            </Link>
                          </li>
                        </ul>
                        <div
                          className="custom_tabcontent tab-content lib-content"
                          id="myTabContent"
                        >
                          <div
                            className="custom_tabpane tab-pane fade show active"
                            id="tabsc58"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Effective therapy is available for Gout.
                              </p>
                              <p className="desc">Treatment includes</p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    <strong>
                                      Treatment of the acute attack
                                    </strong>
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    <strong>
                                      Long term treatment to prevent attacks
                                    </strong>
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc59"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Treatment of the acute attack is aimed at pain
                                relief & control of inflammation. This does not
                                lower the blood uris acid level or prevent
                                future attacks.
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    NSAIDs used for pain relief & control of
                                    inflammation. If one has kidney failure due
                                    to gout/ other comorbidities, NSAIDs cannot
                                    be used
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Corticosteroids a short course is used for
                                    effective rapid control of inflammation.
                                    However, there is no role for long term
                                    corticosteroids.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Colchicine this is not a pain killer but is
                                    very effective in reducing the uric acid
                                    related joint inflammation.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc60"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                This is a long term treatment & aims to prevent
                                future attacks by controlling the blood uric
                                acid levels. These work either by reducing the
                                uric acid production in the body or by
                                increasing its excretion in the urine.
                              </p>
                              <p className="desc">
                                These are started after an acute attack has
                                settled. Initially there is a higher risk of a
                                gouty arthritis attack after the urate lowering
                                therapy is started. Your doctor will generally
                                continue NSAIDs/ colchicine for a few months
                                after this therapy is started to take care of
                                this risk.
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Allopurinol: This reduces the uric acid
                                    production in the body. One is started on a
                                    low dose & the dose is gradually adjusted
                                    over a period of time based on the blood
                                    uric acid levels. Allopurinol is broken down
                                    & excreted by the kidneys.{" "}
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Febuxostat: this reduces the uric acid
                                    production in the body. One is started on a
                                    low dose & the dose is gradually adjusted
                                    over a period of time based on the blood
                                    uric acid levels. This is broken down by the
                                    liver & is preferred over allopurinol if one
                                    ha s a kidney failure.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Probenecid: This increases the uric acid
                                    excretion. This is not widely available &
                                    hence not commonly used.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="custom_tabpane tab-pane fade"
                            id="tabsc61"
                          >
                            <div className="summary_block">
                              <p className="desc">
                                Diet is extremely important in prevention of
                                gout attacks. Many food items can increase the
                                blood uric acid levels & trigger an attack.
                              </p>
                              <ul className="list-unstyled list_bullet ms-3">
                                <li>
                                  <span className="desc">
                                    Alcohol- gets converted into uric acid in
                                    the body. Beer is particularly important as
                                    it can lead to high uric acid levels. Wine
                                    consumption does not lead to an increase in
                                    the uric acid levels.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Water intake: Water helps kidneys flush uric
                                    acid in the urine. One should drink at least
                                    2 litres of water daily.
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Sweetened soft drinks: these contain high
                                    fructose corn syrup. This gets converted to
                                    uric acid in the body & should be avoided
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Vegetables & low fat/ no fat dairy products
                                    are recommended
                                  </span>
                                </li>
                                <li>
                                  <span className="desc">
                                    Meat & seafood are a major culprit & their
                                    consumption needs to be moderated.
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </section>
                      {/* <!-- END FOR > SECTION TREATMENT --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <!-------- START MODAL VIDEO IFRAME  --------> */}
      <div className="custom_modal modal fade" id="modalvideo1">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    // loading="lazy"
                    // className="iframe_video"
                    // width="100%"
                    // height="315"
                    className="p-0"
                    src="https://www.youtube.com/embed/avTq1lgSqcw"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo2">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/jTJ4RZa4dVA"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo3">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="WWI0CJCLkDc">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/avTq1lgSqcw"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo4">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/kMYTfX8qaX0"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo5">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/R4IC0M-ux3A"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo6">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/1V8dOfZ6P-Y"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo7">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/CkwqccIETZE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo8">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/O8yivg8iU14"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo9">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/cnJ2Avk2w9s"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo10">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/jZzJ5pOCzGc"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo11">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/P35PbwXIBVo"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo12">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/Cxm3lo3gvyQ"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo13">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/vwtMgNIlgP4"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo14">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/RydO54_hBTE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo15">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/awXyym0PnkE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo16">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/e-ak4nAnHp0"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo17">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/OGsBYhchyK4"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo18">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/tiSjBwxSS00"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo19">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/q4qAJjSOOC0"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo20">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/rFpkrIw9ALk"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo21">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/O-eSSltifjQ"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo22">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/EA7rMib_PAg"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo23">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/_09q97B19lE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo24">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/Q8TML2A6-yM"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo25">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/J2r4P_PWJ5c"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo26">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/_B6tIvXJE8I"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo27">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/lbVp8oE49qE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo28">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/oq1Rjg0GXGY"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo29">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/IZB9cm6zpBg"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo30">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/IZB9cm6zpBg"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo31">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/Zm5QOZWJX5A"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo32">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/gEkm4Z94IgE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo33">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/a4lvOenKgtc"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo34">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/lQw1ZxOhbQs"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo35">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/WmuV1TtJj8Q"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo36">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/HWK89hgg_0Y"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo37">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/JXGcmMS8Tco"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo38">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/IYZ5ndZA6Bw"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo39">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="jYzIMxK1tPs">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/jYzIMxK1tPs"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo40">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/ZehaJbyZ6F0"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo41">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/GtUNQq7D2bw"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo42">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/Kn2u_RsAEVE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo43">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/FRKbRdLz3iE"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo44">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/tqEYh78_eFI"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo45">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/aJA4B1VR4hU"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo46">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/tEToAWeMWrI"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo47">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/PYOqMsilAzY"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo48">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/Z0ymx_PDWG0"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo49">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/x5MjCjPp29c"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo50">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/MPFII-Amu6I"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo51">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/MQ4cqdA8VNw"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo52">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/jjd0EYE0mGI"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo53">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/kfcUethnyWs"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo54">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/oE4l8eYi_Q4"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo55">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/oc2ORUf99pg"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo56">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/NoSedN5AGd4"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="custom_modal modal fade" id="modalvideo57">
        <div className="custom_big_width modal-dialog">
          <div className="custom_modalcontent modal-content">
            <div className="custom_mh modal-header border-0">
              <button
                type="button"
                className="btn-close btn_close yt_btn_close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body  library-body">
              <div className="video_frame">
                <div className="embed-youtube" data-video-id="">
                  <iframe
                    loading="lazy"
                    className="iframe_video"
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/xFMXHN6V-14"
                    title="Tofacitinib for ankylosing spondylitis- side effects & precautions"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                  <div className="embed-youtube-play"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LibraryPage;
